import { ShopItemStatus, PurchaseResult } from "../model/LanzacoinShopItem";
import { getBaseApiUrl, promiseRequest } from "./ServiceApi";

export class LanzacoinShopApi {
    private getBaseUrl(): string {
        return getBaseApiUrl() + "lanzacoinShop/";
    }

    async getShopStatus(): Promise<ShopItemStatus[]> {
        const url = this.getBaseUrl() + "status/";
        const result = await promiseRequest(url, "GET", undefined, true);
        return result as ShopItemStatus[];
    }

    async purchase(shopItemId: number): Promise<PurchaseResult> {
        const url = this.getBaseUrl() + "purchase/";
        const result = await promiseRequest(url, "POST", { shop_item_id: shopItemId }, true);
        return result as PurchaseResult;
    }

    async getActiveHighlights(): Promise<number[]> {
        const url = this.getBaseUrl() + "activeHighlights/";
        const result = await promiseRequest(url, "GET", undefined, true);
        return result as number[];
    }
}
